// extracted by mini-css-extract-plugin
module.exports = {"typeLabel":"bookTypeLabel_typeLabel__3vHzB","typeLabelAlt":"bookTypeLabel_typeLabelAlt__3M1eG","typeLabelGroup":"bookTypeLabel_typeLabelGroup__3H62E"};